"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M2.042 15.958A2.505 2.505 0 0 1 0 13.5v-2C0 10.122 1.122 9 2.5 9c.458 0 .884-.228 1.139-.609l.851-1.278A2.495 2.495 0 0 1 6.57 6h7.228c.565 0 1.12.195 1.562.548L19.3 9.7c.242.194.545.3.854.3H21c1.949 0 3 1.803 3 3.5 0 1.268-.851 2.259-2.043 2.462A2.505 2.505 0 0 1 19.5 18a2.505 2.505 0 0 1-2.45-2H6.95a2.505 2.505 0 0 1-2.45 2 2.505 2.505 0 0 1-2.458-2.042Zm.022-1.023A2.505 2.505 0 0 1 4.5 13c1.207 0 2.217.86 2.45 2h10.1c.233-1.14 1.243-2 2.45-2 1.186 0 2.182.83 2.437 1.94.577-.162 1.063-.65 1.063-1.44 0-1.005-.533-2.5-2-2.5h-.845a2.371 2.371 0 0 1-1.479-.52l-3.94-3.151A1.509 1.509 0 0 0 13.798 7H6.57c-.502 0-.969.25-1.248.668l-.851 1.277A2.364 2.364 0 0 1 2.5 10c-.827 0-1.5.673-1.5 1.5v2c0 .676.45 1.248 1.064 1.435ZM4.5 14c-.827 0-1.5.673-1.5 1.5S3.673 17 4.5 17 6 16.327 6 15.5 5.327 14 4.5 14Zm15 0c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5Zm-3-3h-5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0V10h4.5a.5.5 0 0 1 0 1Zm-7 0h-4a.5.5 0 0 1-.447-.723l1-2a.5.5 0 1 1 .895.447L6.309 10H9.5a.5.5 0 0 1 0 1Zm4 2h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1Z",
    clipRule: "evenodd"
  })]
});